import React, { Suspense } from "react";
import { createBrowserRouter, Navigate } from "react-router";
import { LayoutArea } from "shared/components/page_layout/layoutarea.component";
import { NotFoundComponent } from "shared/components/error_handling/not_found.component";
import AccessControlGuard from "shared/guards/accesscontrol.guard";
import { UserRole } from "authentication/userrole";
import { SpinnerComponent } from "shared/components/spinner/spinner.component";
import { ROUTES } from "./routes";

const LazyHomeComponent = React.lazy(() =>
  import("./home/home.component").then((m) => ({ default: m.HomeComponent })),
);
const LazyProcessRunsOverviewComponent = React.lazy(() =>
  import("./home/processRuns/overview/processRuns_overview.component").then(
    (m) => ({
      default: m.ProcessRunsOverviewComponent,
    }),
  ),
);
const LazyProcessRunDetailComponent = React.lazy(() =>
  import("./home/processRuns/detail/processRun_detail.component").then((m) => ({
    default: m.ProcessRunDetailComponent,
  })),
);

const withSuspense = (element: React.ReactNode) => (
  <Suspense fallback={<SpinnerComponent />}>{element}</Suspense>
);

export const router = createBrowserRouter([
  {
    path: "/",
    element: <LayoutArea />,
    children: [
      {
        index: true,
        element: <Navigate replace to={ROUTES.HOME} />,
      },
      {
        path: "home",
        handle: { breadcrumb: "Breadcrumb_Start" },
        element: (
          <AccessControlGuard allowedRoles={[UserRole.MceViewer, UserRole.MceOperator]}>
            {withSuspense(<LazyHomeComponent />)}
          </AccessControlGuard>
        ),
        children: [
          {
            path: "process-runs",
            handle: { breadcrumb: "Breadcrumb_Start_ProcessRuns" },
            element: withSuspense(<LazyProcessRunsOverviewComponent />),
            children: [
              {
                path: ":id",
                handle: { breadcrumb: "Breadcrumb_Start_ProcessRuns_Detail" },
                element: withSuspense(<LazyProcessRunDetailComponent />),
              },
            ],
          },
          {
            path: "*",
            element: <NotFoundComponent />,
          },
        ],
      },
      {
        path: "*",
        element: <NotFoundComponent />,
      },
    ],
  },
]);
